import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { DateService, DateUnit } from "@app/services/date.service";
import { lastValueFrom } from "rxjs";
import { EBPMSStatus } from "./_models/EBPMSStatus";
import { IBrakePerformanceScoreHistory } from "./_models/IBrakePerformanceScoreHistory";
import { IBrakePerformanceStatus } from "./_models/IBrakePerformanceStatus";
import { IBrakePerformanceData } from "./_models/IBrakePerformanceData";

@Injectable()
export class EBPMSService {

    constructor(private readonly httpClient: HttpClient, private readonly dateService: DateService) {
    }

    async getLatestBrakePerformanceDataForAccount(): Promise<IBrakePerformanceData[]> {    
        const options = { params: {} as HttpParams }
        options.params["IsActive"] = true;

        return await lastValueFrom(this.httpClient.get<IBrakePerformanceData[]>(`/api/brakeperformance/latestdata`, options));
    }

    async getBrakePerformanceStatusesForVehicle(vehicleId: number): Promise<IBrakePerformanceStatus[]> {
        const options = { params: {} as HttpParams }
        options.params["vehicleId"] = vehicleId;    

        return await lastValueFrom(this.httpClient.get<IBrakePerformanceStatus[]>(`/api/brakeperformance/status`, options))
    }

    async getBrakePerformanceScoreHistory(vehicleId: number): Promise<IBrakePerformanceScoreHistory[]> {
        const options = { params: {} as HttpParams }
        options.params["vehicleId"] = vehicleId;                
                
        return await lastValueFrom(this.httpClient.get<IBrakePerformanceScoreHistory[]>(`/api/brakeperformance`, options));
    }

    async getLatestBrakePerformanceValue(vehicleId: number): Promise<IBrakePerformanceScoreHistory> {
        return await lastValueFrom(this.httpClient.get<IBrakePerformanceScoreHistory>(`/api/brakeperformance/latestscore/${vehicleId}`));
    }

    mapStatusToScoreHistory(scoreHistory: IBrakePerformanceScoreHistory[], performanceStatus: IBrakePerformanceStatus[]): IBrakePerformanceScoreHistory[] {
        return scoreHistory.map(score => {

            const matchingStatus = performanceStatus.find(status =>
                score.CalculatedTime >= status.StartTime &&
                (status.EndTime ? score.CalculatedTime <= status.EndTime : true)
            );

            if (matchingStatus) {
                score.Status = matchingStatus.Status;
            }

            return score;
        });
    }

    isLatestEBPMSHistoryOutOfDate(latest: IBrakePerformanceData): boolean {        
        var minTime = this.dateService.addOrSubtractTime(new Date, -1, DateUnit.Day);
        return this.dateService.isAfter(minTime, latest.CalculatedTime);        
    }

    getStatusIcon(status: EBPMSStatus): string {
        switch (status) {
            case EBPMSStatus.Good:
                return "fa-regular fa-circle-check"

            case EBPMSStatus.Warning:
                return "fa-regular fa-circle-exclamation";

            case EBPMSStatus.Unknown:
            default:
                return "fa-regular fa-circle-question"
        }
    }
}
